<template>
  <div class="culture">
    <div>
      <div class="culture-item">
        <div>企业愿景</div>
        <div>成为客户信赖、员工自豪、中国领先的产业互联网科技赋能平台</div>
      </div>
      <div class="culture-item">
        <div>企业核心价值观</div>
        <div>受客户信赖，对公众诚信</div>
      </div>
      <div class="culture-item">
        <div>企业精神</div>
        <div>开拓创新，追求卓越</div>
      </div>
    </div>
    <div>
      <div class="culture-item">
        <div>企业宗旨</div>
        <div>发展员工成就客户</div>
      </div>
      <div class="culture-item">
        <div>经营理念</div>
        <div>诚信、创新、合作、责任</div>
      </div>
      <div class="culture-item">
        <div>企业使命</div>
        <div>为社会创造财富，为客户创造价值</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "culture",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.culture {
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
}
.culture-item {
  margin-bottom: 80px;
  div:nth-child(1) {
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
  }
  div:nth-child(2) {
    margin-top: 15px;
    font-weight: 400;
    font-size: 21px;
    color: #666666;
    line-height: 30px;
  }
}
</style>
